// extracted by mini-css-extract-plugin
export default {"settingsContainer":"Settings_settingsContainer__ulMvA","noDataText":"Settings_noDataText__SSGXc"};